function emailValidator(email) {
  const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return re.test(String(email).toLowerCase());
}

function jmbgValidator(jmbg) {
  const re = /^\d{13}$/;
  return re.test(String(jmbg));
}

module.exports = {
  emailValidator,
  jmbgValidator,
  // Add other validators here
}
